(function (window, angular, undefined) {
angular.module('formApp')
    .directive('specialistBreedModalDual', ['$templateCache', '$document', '$compile', 'scrollToPoint', '$timeout',
        function ($templateCache, $document, $compile, scrollToPoint, $timeout) {
        var template = $templateCache.get('directives/specialist-breed-modal/templates/specialist-breed-modal-dual.html');
        return {
            restrict: 'EA',
            scope: {
                pet: "=",
                isSpecialBreedDual: '=',
                isBannedBreedDual: '=',
                index: '&'
            },
            link: function($scope, element, attr) {

                $scope.isSpecialBreedDual = $scope.$eval(attr.isSpecialBreedDual);
                $scope.isBannedBreedDual = $scope.$eval(attr.isBannedBreedDual);
                $scope.index = $scope.$eval(attr.index);

                // Deploy only one modal specific to ID of pet and if specialist/banned breed
                var target = 'SPECIAL.BREED.DUAL.' + $scope.index.toUpperCase();

                var childScope,
                    popup,
                    breedDetails,
                    bodyEl = $document.find('body'),
                    openModalButton = document.activeElement,
                    list = document.querySelectorAll('body > *:not(.modal)');

                $timeout(function() {
                    breedDetails = document.getElementById($scope.index);   
                }, 100); 

                $scope.close = function() {
                    // reset values and clear breed input field into error state
                    $scope.isSpecialBreedDual = false;
                    // remove pop up from the DOM
                    removePopup();
                    // focus back to breed input field
                    breedDetails.focus();
                };

                $scope.call = function() {
                    window.location.href = 'tel:03450771934';
                };

                function removePopup() {
                    childScope.$destroy();
                    popup.remove();
                }
                
                $scope.$on(target, function() {
                    if (popup) {
                        removePopup();
                    }
                    $scope.$apply(function() {
                        childScope = $scope.$new();
                        popup = $compile(template)(childScope);
                        bodyEl.append(popup);

                        $timeout(function() {    
                        //Accessibility - focus in modal window
                        var modalMain = document.getElementById('specialistBreedModalDual' + $scope.index),
                        p = document.getElementById('skipnav'),
                        modal = document.querySelector('#specialistBreedModalDual' + $scope.index + ' .modal-dialog'),
                        closeModalButton = document.querySelector('#specialistBreedModalDual' + $scope.index + ' .modal-close'),
                        returnQuote = document.querySelector('#specialistBreedModalDual' + $scope.index + ' .return-quote'); 

                        swap();  

                        focusDialog();                 
                                                                    
                        function focusDialog(){  
                            angular.element(modalMain).attr({ 'aria-hidden': 'false','tab-index': '0','open': true});  

                            modal.focus();

                            angular.element(closeModalButton).on('keydown', function(e){
                                if ((e.which === 9 && !e.shiftKey)) {
                                    e.preventDefault();
                                    modal.focus();
                                }
                            });

                            angular.element(modal).on('keydown', function(e){
                                if ((e.which === 9 && e.shiftKey)) {
                                    e.preventDefault();        
                                    closeModalButton.focus();
                                }
                            }); 
                        }                                       

                        function swap(){
                            p.parentNode.insertBefore(modalMain, p);
                        } 
                        //end of accessibility

                    });

                }, 100);
            
            });
        }
    };
}]);
})(window, window.angular);
        
